module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.task.isDone()) ? _c('div', {
    staticClass: "done-task-item"
  }, [(_vm.element_options.icon_position == "item") ? _c('div', {
    staticClass: "done-task-icon",
    class: _vm.iconClass(_vm.task)
  }) : _vm._e(), (_vm.element_options.icon_position == "text") ? _c('div', {
    staticClass: "done-task-icon text-icon",
    class: _vm.iconClass(_vm.task)
  }) : _vm._e(), _c('div', {
    staticClass: "done-task-text"
  }, [_c('div', {
    staticClass: "done-task-status overflow-ellipsis"
  }, [_vm._v(_vm._s(_vm.task_description))])]), _c('div', {
    staticClass: "done-task-date"
  }, [_c('span', [_vm._v(_vm._s(_vm.task.doneAtDate()))]), (!_vm.task.undefined_time) ? _c('span', [_vm._v("- " + _vm._s(_vm.task.doneAtHour()))]) : _vm._e()]), (_vm.element_options.show_contact) ? _c('div', {
    staticClass: "done-task-contact clickable",
    on: {
      "click": function($event) {
        return _vm.toggleTaskBar()
      }
    }
  }, [_c('div', {
    staticClass: "spacer-15"
  }), _c('div', {
    staticClass: "contact-name"
  }, [_c('span', [_vm._v(_vm._s(_vm.task.contact.full_name))])]), _c('div', {
    staticClass: "contact-business"
  }, [_vm._v(_vm._s(_vm.task.contact.business.name))])]) : _vm._e(), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "responsible"
  }, [_c('span', {
    staticClass: "responsible-lable"
  }, [_vm._v("Responsável:  ")]), _c('span', {
    staticClass: "responsible-name"
  }, [_vm._v(_vm._s(_vm.task.assigned_to.name || _vm.current_user.name))])]), (_vm.element_options.show_comment && _vm.task.comment) ? _c('div', {
    ref: "element_id",
    staticClass: "comment-task-action task-comment-icon clickable",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "right",
      "title": _vm.tooltip_text
    }
  }) : _vm._e(), (!_vm.disable_toggle_done) ? _c('div', {
    staticClass: "done-toggle glyphicon glyphicon-repeat clickable",
    on: {
      "click": function($event) {
        return _vm.toggleDone()
      }
    }
  }) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07ea2234!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/manual_tasks/done_tasks/list_item.vue
// module id = 1009
// module chunks = 1